import { ReactComponent as MailIcon } from '../assets/icons/email/mail.svg';
import { ReactComponent as SentIcon } from '../assets/icons/email/sent.svg';
import { ReactComponent as DraftIcon } from '../assets/icons/email/draft.svg';
import { ReactComponent as TrashIcon } from '../assets/icons/email/trash.svg';

const emailIcons = {
  MailIcon,
  SentIcon,
  DraftIcon,
  TrashIcon,
};

export default emailIcons;
